import React, { Component } from 'react';

// import LogoAlcaldia from './../../images/LogoAlcaldia.png';
// import EsloganAlcaldia from './../../images/EsloganAlcaldia.png';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

// import Modal from './../../Modal/containers/ModalContainer';
// import Loader from './../../Modal/containers/LoaderContainer';

import { LOGIN } from './../../constants/strings/StringsDashboard';


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as modalActs from './../../Actions/Modal';
import * as sessionActs from './../../Actions/Session'

import './login.css';

// import { sendService } from './../../Services/service';



class LoginContainer extends Component {
  state = {
    user: '',
    pass: ''
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  keyPress = (e) => {
    if (e.which === 13) {
      this.handlerSubmit();
    }
  }

  handlerSubmit = async () => {
    this.props.modalActions.openLoader();
    this.props.sessionActions.loginAsync(this.state.user, this.state.pass);
  }

  componentDidMount(){
    this.props.modalActions.closeLoader();
  }

  render() {
    return (
      <>
        <div className="background">
          <div className="container-form">
            <div className="line line-100 text-center">
              {/* <img src={EsloganAlcaldia} alt="Eslogan Alcaldia" className="Alcaldia-logo"></img> */}
            </div>
            {(this.props.session.login === 'fail') && <p className="invalid-session">Datos de sesión inválidos</p>}
            <div className="input-div">
              <TextField
                label={LOGIN.USER}
                className={'input-text'}
                value={this.state.user}
                onChange={this.handleChange('user')}
                onKeyPress={this.keyPress}
                margin="normal"
                variant="outlined"
              />
            </div>
            <div className="input-div">
              <TextField
                label={LOGIN.PASSWORD}
                className={'input-text'}
                value={this.state.pass}
                onChange={this.handleChange('pass')}
                onKeyPress={this.keyPress}
                margin="normal"
                variant="outlined"
                type="password"
              />
            </div>
            <div className="button-div">
              <Button variant="contained" className={"button-submit"} onClick={this.handlerSubmit}>
                {LOGIN.LOGIN}
              </Button>
            </div>
          </div>
        </div>
      </>
    )
  }
}


function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch),
  }
}

function mapStateToProps(state, props) {
  return {
    session: state.session
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);